import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
let apiPath = '/tjkx_xhbg' // 正式环境的路径
if (['https://tjkx.govfu.com', 'http://localhost:8080', 'http://192.168.1.200:8080'].includes(location.origin)) {
    apiPath = '/api/xhbg' // 测试环境的路径
}
axios.defaults.baseURL = apiPath
axios.defaults.withCredentials = true
axios.interceptors.request.use(
    config => {
        return config
    },
    err => {
        return Promise.reject(err)
    })
axios.interceptors.response.use(
    response => {
        // 未登录
    if (response.data.code === 1004) {
        let host = location.host;
        let protocol = location.protocol;
        location.href = protocol + '//' + host + '/tjcastssshttglptindex/login' + '?redirect=' + encodeURIComponent(location.href)
    }
    return response
    },
    error => {
        console.log(error)
        return Promise.reject(error.response.data)
    }
)
export default axios
